AuthRoute = require 'mixins/authenticated-route'

App.DeliveryZonesRestaurantCreateZoneRoute = Em.Route.extend AuthRoute,
  setupController: (controller, model) ->
    @_super(arguments...)
    restaurant = @modelFor('delivery.zones.restaurant')
    organization = @controllerFor('delivery').get('organization')
    controller.setProperties({ restaurant, organization })